export function hoverJiggleAnimate(el) {
  console.log('test');
  el.addEventListener('animationend', function() {
    el.classList.toggle('hover-animate', false);
  });

  el.addEventListener('mouseenter', function() {
    el.classList.toggle('hover-animate', true)
  });
}
